<template>
    <div class="calendar">
        <van-popup v-model="show"  position="right" :close-on-click-overlay="false">
            <img class="right-icon" src="@/assets/home/right_modal@2x.png" @click="changePopup" />
            <div class="calendar-wrap">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    @load="onLoad"
                >
                    <ul class="list" v-if="list.length > 0">
                        <CalendarItem class="item" :item="item" v-for="(item, index) in list" :key="index" />
                    </ul>
                    <div class="list-none" v-else>
                        <img :src="theme.u_general_icon_empty || icon" />
                        <p>暂时还没有排期，敬请期待</p>
                    </div>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>

<script>
import http from "@/utils/axios";
import CalendarItem from './calendarItem';
export default {
    props: {
        popupShow: Boolean
    },
    data() {
        return {
            loading: false,
            finished: false,
            list: [],
            pageNum: 1,
            icon: require('@/assets/image/empty_icon.png')
        }
    },
    components: {CalendarItem},
    created() {
        this.onLoad()
    },
    computed: {
        show: {
            get() {
                return this.popupShow
            },
            set() {
                this.$emit('update:popupShow', this.show)
            }
        }
    },
    methods: {
        changePopup() {
           this.$emit('update:popupShow', !this.show)
        },
        onLoad() {
            http({
                url: 'order/app/goods-activity-calendar/pageList',
                method: 'post',
                parmes: {
                    pageNum: this.pageNum++,
                    pageSize: 10
                }
            }).then(rps=>{
                if(rps.code == 200) {
                    if(rps.data.list.length!=0) {
                        this.list.push(...rps.data.list);
                        this.loading = false;
                    } else {
                        this.finished = true;
                    }
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .van-popup.van-popup--right {
    overflow-y: inherit;
}
.calendar {
    font-size: 24px;
    .right-icon {
        width: 40px;
        height: 100px;
        position: absolute;
        top: 50%;
        left: -40px;
        transform: translateY(-50%);
    }
    .calendar-wrap {
        width: 675px;
        height: 100vh;
        position: relative;
        overflow-y: scroll;

        .list {
            padding: 0 20px;
        }

        .list-none {
            width: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;

            img {
                width: 220px;
                height: 220px;
            }
            p {
                margin-top: 45px;
                color: #999;
            }
        }
    }
}
</style>